export const appId = Number(process.env.REACT_APP_APP_ID);
